import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Paper
} from "@mui/material";
import UserService from "../services/user-service";

export default function ResetPasswordRequest({ onRequest }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus("loading");
    setErrorMsg("");

    var associationToReset={
      email: email
    }

    UserService.resetRequest(associationToReset).then(
      response => {
        setStatus("success");
      },
      error => {
        setStatus("error");
        setErrorMsg( "Errore durante la richiesta.");
      }
    );

  };

  return (
    <Paper sx={{ p: 4, maxWidth: 400, mx: "auto", mt: 6 }} elevation={3}>
      <Typography variant="h5" mb={2}>Reset Password</Typography>

      {status === "success" ? (
        <Alert severity="success">
          Se l’email esiste nel sistema, riceverai il link per reimpostare la password.
        </Alert>
      ) : (
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            fullWidth
            required
            type="email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {status === "error" && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMsg}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            disabled={status === "loading"}
          >
            {status === "loading" ? <CircularProgress size={24} /> : "Invia Link di Reset"}
          </Button>
        </form>
      )}
    </Paper>
  );
}